import { Guid } from '@web/utils';

export class AdminMultimediaImageUpload {
  public constructor(
    private readonly data: {
      id: Guid;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }
}
